// src/pages/NainHome.jsx
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";

const NainHome = () => {
  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Learning & Development");

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  const groupNames = [
    { label: "Digital Income", emoji: "💰" },
    { label: "Learning & Development", emoji: "📚" },
    { label: "Great Citizen", emoji: "👥" },
    { label: "People & Innovation", emoji: "👥" },
    { label: "PehchaanSetu", emoji: "🌉" },
    { label: "Citizen Self Reflection", emoji: "🪞" },
    { label: "Artificial Intelligence", emoji: "👳" },   
  ];

  // FULL SAKSHAM Nain Menu Buttons
  const menuButtons1 = [
      // 💰 DIGITAL INCOME
    { label: "Monthly Digital Income", emoji: "💻🌱", link: "/nain-bookworld", group: "Digital Income" },
    { label: "Kharcho Jeeto", emoji: "💰", link: "/kharchojeeto", group: "Digital Income" },
    { label: "Referral Income", emoji: "🔗", link: "/orderflow-earning-estimator", group: "Digital Income" },
    { label: "Resell", emoji: "♻️", link: "/nain-enroll", group: "Digital Income" },
    { label: "Rewarding Ads", emoji: "🎁📢", link: "/visigift-home", group: "Digital Income" },
    { label: "Rewarding Videos", emoji: "🎥🌾", link: "/orderflow-spotbuy", group: "Digital Income" },
    { label: "Digital Boutique", emoji: "🛍️", link: "/digiboutique", group: "Digital Income" },

    // 📚 Learning & Development
    { label: "SMILE Learning", emoji: "🗓️", link: "/smile-bookworld", group: "Learning & Development" },
    { label: "Bookshelf", emoji: "📖", link: "/bookshelf", group: "Learning & Development" },
    { label: "Podcast", emoji: "️🎙️", link: "/podcast-mylist", group: "Learning & Development" },
    { label: "indiaTube", emoji: "️▶️", link: "/naintube", group: "Learning & Development" },

    // 🪞 Citizen SHELF REFLECTION
    { label: "National Digital Card", emoji: "📘", link: "/nain-digitalcard", group: "Citizen Self Reflection" },
    { label: "Self Management", emoji: "🙋‍♀️", link: "/nain-self-chronicles", group: "Citizen Self Reflection" },
    { label: "Personal Diary", emoji: "📔", link: "/mydiary-home", group: "Citizen Self Reflection" },
    { label: "DeepThinking", emoji: "🧩", link: "/fivewhys-analysis-home", group: "Citizen Self Reflection" },
    { label: "Focus Timer", emoji: "⏱️", link: "/nain-focustimerstart", group: "Citizen Self Reflection" },
    { label: "IKIGAI", emoji: "🌸", link: "/myprofile-ikigai", group: "Citizen Self Reflection" },
    { label: "Personal AI Counselling", emoji: "🧠", link: "/aicounselling", group: "Citizen Self Reflection" },

     // 👥 RIM 
    { label: "Great Citizen", emoji: "👥", link: "/rim", group: "Great Citizen" },

    // 👥 People & Innovation
    { label: "Innovations", emoji: "💡", link: "/nain-innovationhub", group: "People & Innovation" },
    
    // 🔗 PehchaanSetu 
    { label: "PehchaanSetu", emoji: "🔗", link: "/pehchaansetu", group: "PehchaanSetu" },

    // Artificial Intelligence
    { label: "Ask Thinky", emoji: "👳", link: "/agenticsim", group: "Artificial Nain Intelligence" },
  ];

  const filteredButtons = menuButtons1.filter((btn) => btn.group === activeTab);

  return (
    <div className="min-h-screen flex flex-col bg-black text-gray-100 font-sans">
      <header className="sticky top-0 z-50 bg-black border-b border-blue-400 px-4 py-3 flex items-center justify-between">
        <div className="flex flex-col">
          <div className="text-lg lg:text-xl font-bold text-teal-300">👥 Nain</div>
          <div className="text-[11px] text-gray-200">Natinal Integration!</div>
        </div>

        <div className="hidden md:flex items-center gap-3">
          {isLoggedIn ? (
            <>
              <div className="text-xs lg:text-sm text-teal-300">{userName}</div>
              <button
                onClick={handleLogout}
                className="mt-4 p-2 rounded-md bg-red-600 hover:bg-red-700 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="px-3 py-1 rounded-full border border-gray-700 text-sm text-gray-200 hover:bg-gray-800"
              >
                Login
              </button>
            </>
          )}
        </div>
        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden w-8 h-8 flex items-center justify-center text-2xl text-teal-300"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {/* Mobile menu content */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-gray-900 border-b border-gray-800 px-4 py-3">
          {isLoggedIn ? (
            <div className="flex flex-col items-center gap-3">
              <div className="text-teal-300 text-xs lg:text-sm font-medium">{userName}</div>
              <div className="flex gap-3">
                <button
                  onClick={handleLogout}
                  className="p-2 rounded-md bg-red-600 hover:bg-red-700"
                >
                  ⏻
                </button>
              </div>
            </div>
          ) : (
            <div className="flex justify-center gap-6">
              <Link to="/login" className="text-teal-300">Login</Link>
            </div>
          )}
        </div>
      )}

      <div className="bg-cyan-800 text-white text-xs sm:text-sm py-2">
        <div className="px-1 flex flex-wrap justify-center gap-4">
          <a href="/nain-whysakshamnain" className="hover:text-yellow-200">💭 About SAKSHAM</a>
          <a href="/nain-vsai" className="hover:text-yellow-200">🤖 SAKSHAM & AI</a>
          <Link to="/litenshort" className="hover:text-yellow-200">🗞️ Short News</Link>
          <a href="/fundlanes" className="hover:text-yellow-200">💰 Funding</a>
          <a href="/ledger" className="hover:text-yellow-200">📊 ERP</a>
          <a href="/growsure" className="hover:text-yellow-200">💪 PMMY</a>
          <a href="/nain-think5whysfaq" className="hover:text-yellow-200">🤔 FAQ</a>
          <a href="/agenticsim" className="hover:text-yellow-200">🤖 Ask AI</a>
        </div>
      </div>

      <div className="mt-1 mb-1 px-3 py-2 border-b border-gray-500">
        <div className="grid grid-cols-3 lg:grid-cols-5 gap-2  border-gray-600 place-items-center">
          {groupNames.map((group) => (
            <button
              key={group.label}
              onClick={() => setActiveTab(group.label)}
              className={`flex flex-col items-center justify-center w-full px-2 py-2 rounded-md text-xs sm:text-sm font-medium transition ${
                activeTab === group.label
                  ? "bg-teal-700 text-yellow-200"
                  : "bg-gray-800 text-gray-200 hover:bg-gray-700"
              }`}
              aria-pressed={activeTab === group.label}
            >
              <span className="text-lg">{group.emoji}</span>
              <span className="mt-1 text-center">{group.label}</span>
            </button>
          ))}
        </div>
      </div>

      <main className="flex-grow mx-auto px-3 py-2 w-full justify-center items-center text-center">
        <div className="grid grid-cols-3 lg:grid-cols-5 gap-1 place-items-center">
          {filteredButtons.length === 0 ? (
            <div className="col-span-3 sm:col-span-3 md:col-span-5 text-center text-gray-400">
              No items in this category.
            </div>
          ) : (
            filteredButtons.map((btn, idx) => (
              <button
                key={`${btn.label}-${idx}`}
                onClick={() => navigate(btn.link)}
                className="flex flex-col items-center justify-center w-full px-1.5 py-1 rounded-md text-[10px] sm:text-xs font-medium transition bg-transparent hover:bg-teal-700 hover:text-yellow-200 text-gray-100 break-words text-center shadow-sm"
                title={btn.label}
              >
                <span className="text-base sm:text-lg">{btn.emoji}</span>
                <span className="mt-1">{btn.label}</span>
              </button>
            ))
          )}
        </div>
      </main>
      <footer className="bg-black border-t border-blue-400 text-white py-4">
        <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-sm text-yellow-200">© 2025 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-teal-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default NainHome;
